import GestionCategorias from './GestionCategorias';

export default function CategoriasPage() {
  return <GestionCategorias />;
}






